'use strict';

var chunk3A5DQBXA_js = require('./chunk-3A5DQBXA.js');
var chunkWVST6R4U_js = require('./chunk-WVST6R4U.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var e = require('react');
var i = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var e__default = /*#__PURE__*/_interopDefault(e);
var i__default = /*#__PURE__*/_interopDefault(i);

var c=i__default.default.footer`
  /* Add your footer styles here */
  padding: 85px 0 80px;
  color: #0F0F10;
`,h=i__default.default.div`
  /* Add container styles */
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 1200px) {
        padding: 0;
        max-width: 1024px;
  }

  @media (min-width: 1600px) {
        padding: 0;
        max-width: 1520px;
  }


`,k=i__default.default.div`
  /* Add row styles */
  display: flex;
  justify-content: space-between;
  gap: 100px;
  padding-top: 56px;

  @media (min-width: 1600px) {
    column-gap: 229px;
  }
`,w=i__default.default.div`
  /* Add left column styles */
  flex-shrink: 0;
`,v=i__default.default.div`
  /* Add right column styles */
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  row-gap: 74px;
  flex: 1;
`,L=i__default.default.div`
  display: flex;
  column-gap: 100px;

  @media (min-width: 1600px) {
    column-gap: 229px;
  }

`,A=i__default.default.ul`
  /* Add footer link styles */
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-10);
  list-style: none;
`,C=i__default.default.ul`
  /* Add social media list styles */
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex; 
  gap: 14px;
  align-items: center;
`,S=i__default.default.div`
  /* Add app download styles */
  display: flex;
  flex-direction: column;
  row-gap: 18px;

  & a {
    width: 174px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

  & img {
    height: 54px;
    width: 183px ;
  }

`,b=i__default.default.div`
  /* Add driving section styles */
  display: flex;
  justify-content: space-between;
  align-items: end;

  &  h4 {
    margin-bottom: 12px;
    color: #717272;
    font-size: 48px;
    font-weight: 700;
    line-height: 72px;
}
`,F=i__default.default.div`
  /* Add driver icon styles */
  width: 286px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`,p=i__default.default.a`
  /* Add link styles */
  color: black;
  text-decoration: none;
`,_=i__default.default.li`
  /* Add list item styles */
  list-style: none;
`,D=i__default.default.div`
  /* Add footer link wrapper styles */
  display: flex;
  flex-direction: column;
  gap: 40px;
`,a=({links:n,title:t})=>{let{tokens:o}=chunkHUKGHOBJ_js.b();return e__default.default.createElement(D,null,e__default.default.createElement(chunkWVST6R4U_js.a,{as:"h3",fontWeight:"bold",size:"350",color:o.text_default_text_primary},chunk3A5DQBXA_js.a((t||"").toLowerCase())),e__default.default.createElement(A,null,n.map(l=>e__default.default.createElement(_,{key:l.title},e__default.default.createElement(p,{href:l.url,target:l.target},l.title)))))},W=({links:n})=>e__default.default.createElement(C,null,n.map((t,o)=>e__default.default.createElement("li",{key:`social-media-${o}`},e__default.default.createElement(p,{onClick:()=>console.log(t.name),href:t.url,target:t.target||"","aria-label":t.title},e__default.default.createElement("img",{src:t.image_url,alt:t.title}))))),I=({links:n})=>e__default.default.createElement(S,null,n.map((t,o)=>e__default.default.createElement(p,{key:o,onClick:()=>console.log(t.title),href:t.url,"aria-label":t.title,style:{display:"block"}},e__default.default.createElement("img",{src:t.image_url,alt:t.title})))),T=({driverImage:n,text:t="Better drives,",subText:o="better lives"})=>e__default.default.createElement(b,null,e__default.default.createElement(chunkWVST6R4U_js.a,{as:"h4",size:"300",color:"#717272"},t,e__default.default.createElement("br",null),o),e__default.default.createElement(F,null,e__default.default.createElement("img",{src:n,alt:"Driving happier car"}))),j=i__default.default.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`,K=({data:n,logo:t,driverIcon:o,bottomText:l})=>{let{tokens:u}=chunkHUKGHOBJ_js.b(),{popular_search:g={},social_media:m={},useful_links:y={},app_links:f={},other_geographies:x={}}=n||{};return e__default.default.createElement(c,null,e__default.default.createElement(h,null,t&&e__default.default.isValidElement(t)&&t,e__default.default.createElement(k,null,e__default.default.createElement(w,null,e__default.default.createElement(a,{links:y.links||[],title:y.title||""})),e__default.default.createElement(v,null,e__default.default.createElement(L,null,e__default.default.createElement(a,{links:g.links||[],title:g.title||""}),e__default.default.createElement(a,{links:x.links||[],title:x.title||""}),e__default.default.createElement(j,null,e__default.default.createElement(chunkWVST6R4U_js.a,{as:"h3",fontWeight:"bold",size:"350",color:u.text_default_text_primary},chunk3A5DQBXA_js.a((m.title||"").toLowerCase())),e__default.default.createElement(W,{links:m.links||[]}),e__default.default.createElement(I,{links:f.links||[]}))),e__default.default.createElement(T,{driverImage:o,text:l,subText:"better lives"})))))};

exports.a = K;
